export const isDev = false ;// 是否开启redux-devtools。生产模式请设置为false
export const version = 'v0.1.2';
export const isPermission = false;
export const BAIDU_API_KEY = 'ChNbu6GBxNgl2mmnrsikYeuEhfQR4mpw'; // 百度地图key,申请地址: http://lbsyun.baidu.com/index.php?title=webapi/guide/webservice-geocoding·
export const BraftControls = [
    'undo', 'redo', 'separator',
    'font-size', 'line-height', 'letter-spacing', 'separator',
    'text-color', 'bold', 'italic', 'underline', 'strike-through', 'separator',
    'superscript', 'subscript', 'remove-styles',  'separator', 'text-indent', 'text-align', 'separator',
    'headings', 'list-ul', 'list-ol', 'blockquote', 'separator',
    'link', 'separator', 'hr', 'separator',
    'media', 'separator',
    'clear'
]



// WEBPACK FOOTER //
// ./src/config.js